import { Button } from '@/components/ui/button';

interface ErrorProps {
  message: string;
  onRetry: () => void;
}

/**
 * Error Component
 * 
 * Error message component with retry button for use in QueryBoundary
 */
export function Error({ message, onRetry }: ErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-4">
      <div className="text-destructive text-center">
        <p className="text-lg font-medium">Error</p>
        <p className="text-sm">{message}</p>
      </div>
      
      <Button onClick={onRetry} className="px-4 py-2">
        Try Again
      </Button>
    </div>
  );
}
